<template>
  <div class="addsite">
    <b-modal id="addsite" ref="AddSiteModel" modal-class="addsite addsitepopup" :lazy="true" centered title="Add a WordPress Site" v-model="show" @ok="addSite" :hide-header-close="true" class="addsitepopup" @show="instializeData" :no-fade="true">
      <div class="prompt-text alert" role="alert">
        The IWP Client Plugin should be installed on the sites before adding them.
      </div>
      <form-alert :message="error.errorMsg" v-for="(error,index) in errors" :key="index"></form-alert>

      <div class="form-group">

        <b-form-group label="WP credentials" label-for="url_input">
          <input id="url_input" ref="urlinput" class="form-control" type="text" @paste="handlePaste('url')" v-model="args.url" placeholder="WP-Admin URL" required />
        </b-form-group>
        <b-form-group label-for="username_input">
          <input id="username_input" class="form-control" type="text" @paste="handlePaste('username')" v-model="args.username" placeholder="Admin Username" required/>
        </b-form-group>
        <b-form-group label-for="username_input">
          <input id="activation_key_input" class="form-control" type="text" @paste="handlePaste('activationKey')" v-model="args.activationKey" placeholder="Activation Key" required/>
        </b-form-group>
          <b-form-group label="Folder Protection" id="exampleInputGroup1"  label-for="httpauth_username">
            <input id="httpauth_username" class="form-control" type="text" placeholder="Username" v-model="currentSite.httpAuth.username" required >
            </input>
          </b-form-group>
          <b-form-group id="exampleInputGroup1"  label-for="wp_admin">
            <password-input idFor="wp_admin" placeholder="password" v-model="currentSite.httpAuth.password"></password-input>
          </b-form-group>
        <b-form-group label="Advanced" class="advanced" label-for="Advanced">
          <advanced value class="m-0" v-model= "currentSite"> </advanced>
        </b-form-group>

      </div>
      <div slot="modal-footer" class="w-100">
        <div class="text-right">
          <b-btn variant="flat" @click="show=false">
            Cancel
          </b-btn>
          <b-btn variant="primary" class="px-3" @click="addSite()" :disabled="buttonLoaders.addSite">
            Add Site
            <spinner size="small" v-if="buttonLoaders.addSite"></spinner>
          </b-btn>
        </div>
      </div>
    </b-modal>
    <edit-site ref="editsite" :site="currentSite"></edit-site>
    <multi-site ref="multisite" @addNetworkSite="addNetworkSite" :site="networkSiteDetails"></multi-site>

  </div>
</template>

<script>
import PlusIcon from "../../assets/plus.svg";
import FormAlert from "../Common/FormAlert";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PasswordInput from '../Common/PasswordInput';
import Advanced from '../Common/Advanced';
import EditSite from './EditSite';
import MultiSite from './MultiSite';

export default {
  name: "addsite",
  components: {
    PlusIcon,
    FormAlert,
    PasswordInput,
    Advanced,
    EditSite,
    MultiSite
  },

  data() {
    return {
      networkSiteDetails:'',  
      show: false,
      url: "",
      addNewGroup: false,
      newGroupName: "",
      selectedGroups: [],
      errors: [],
      buttonLoaders: {
        addSite: false
      },
      args: {
        username: "",
        siteName: "",

        url: "",
        activationKey: ""
      },
      currentSite: {
          callOpt : {
            contentType: 'application/x-www-form-urlencoded',
            SSLVersion: '0',
          },
          httpAuth : {
           username: '', password: '' 
         },
         connectURL: 'default'
       },

    };
  },
  mixins: [validationMixin],
  validations: {
    args: {
      url: {
        required
      },
      username: {
        required
      },
      activationKey: {
        required
      }
    }
  },
  computed: {
    options() {
      return _.map(_.values(this.$store.getters.getGroups), group => {
        return { label: group.name, value: group.groupID };
      });
    }
  },
  watch: {
    addNewGroup(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$refs.groupname.focus();
        }, 100);
      }
    }
  },
  methods: {
    instializeData() {
      //Object.assign(this.$data, this.$options.data());

      Object.assign(this.$data, this.$options.data.apply(this));
      setTimeout(() => {
        this.$refs.urlinput.focus();
      }, 500);
    },
    addSite() {
      this.buttonLoaders.addSite = true;
      let payload = {};
      payload.action = "addSite";
      payload.args = {};
      payload.args.params = {};
      payload.args.params["URL_b64encoded"] = btoa(this.args.url);
      payload.args.params["activationKey"] = this.args.activationKey;
      payload.args.params["username"] = this.args.username;
      payload.args.params["siteName"] = this.args.siteName;
      payload.args.params.callOpt = {};
      payload.args.params.callOpt['SSLVersion'] = this.currentSite.callOpt.SSLVersion;
      payload.args.params.callOpt['contentType'] = this.currentSite.callOpt.contentType;
      payload.args.params['connectURL'] = this.currentSite.connectURL;
      payload.args.params.httpAuth = {};
      payload.args.params.httpAuth['username'] = this.currentSite.httpAuth.username;
      payload.args.params.httpAuth['password'] = this.currentSite.httpAuth.password;
      payload.requiredData = {};
      payload.requiredData['getMultisitesByParentSiteURL'] = {};
      payload.requiredData['getMultisitesByParentSiteURL']['URL_b64encoded'] = btoa(this.args.url);
      payload.requiredData["getSitesV3"] = 1;
      payload.requiredData["getGroupsSitesV3"] = 1;
      payload.requiredData["getPluginsAndThemesV3"] = 1;
      payload.requiredData["getSitesUpdatesV3"] = 1;

      if (this.selectedGroups) {
        payload.args.params["groupIDs"] = _.map(this.selectedGroups, "value");
      }
      if (this.addNewGroup && this.newGroupName) {
        payload.args.params["groupsPlainText"] = this.newGroupName;
      }

      this.$store
        .dispatch("sendAction", payload)
        .then(response => {
          this.buttonLoaders.addSite = false;
          this.$store.commit("SET_SITES", response.data.getSitesV3);
          this.$store.commit("SET_GROUPS", response.data.getGroupsSitesV3);
          this.$store.commit(
            "UPDATE_SITES_UPDATES",
            response.data.getSitesUpdatesV3
          );
          this.$store.commit(
            "UPDATE_PLUGINS_AND_THEMES",
            response.data.getPluginsAndThemesV3
          );
          if (response.actionResult && response.actionResult.detailedStatus) {
            let errors = _.filter(
              response.actionResult.detailedStatus,
              status => {
                return status.status != "success";
              }
            );
            if (errors && errors.length > 0) {
              this.errors = errors;
              return;
            }
          }
          if(response.data.getMultisitesByParentSiteURL && response.data.getMultisitesByParentSiteURL.parentSiteID !=''){
            this.multisite(response.data.getMultisitesByParentSiteURL);
            return;
          }
          this.errors = [];
          this.show = false;
          let openEdit = _.filter(
            response.actionResult.detailedStatus,
            site =>{
              let siteID = site.siteID;
              this.editsite(this.$store.getters.getSites[siteID]);
              return;
            }

          );
          
        })
        .catch(err => {
          this.buttonLoaders.addSite = false;
          
        });
    },
    editsite(site) {
      console.log(site);
      this.currentSite = site;
      if (!this.currentSite.httpAuth) {
        this.currentSite.httpAuth = {};
        this.currentSite.httpAuth['username'] = "";
        this.currentSite.httpAuth['password'] = "";
      }
      this.$refs.AddSiteModel.hide();
      this.$refs.editsite.$refs.editsitemodal.show();
    },
    multisite(multisite){
      this.networkSiteDetails = multisite;
      this.$refs.AddSiteModel.hide();
      this.$refs.multisite.$refs.multisiteModel.show();
    },
    addNetworkSite(value){
      let payload = {};
      payload['requiredData'] = {};
      payload['requiredData']['addBulkNetworkSite'] = {};
      payload['requiredData']['addBulkNetworkSite']['parentSiteID'] = value.parentSiteID;
      payload['requiredData']['addBulkNetworkSite']['selectedSites'] = value.siteName;
      payload['requiredData']["getSitesV3"] = 1;
      payload['requiredData']["getGroupsSitesV3"] = 1;
      payload['requiredData']["getPluginsAndThemesV3"] = 1;
      payload['requiredData']["getSitesUpdatesV3"] = 1;
      return this.$store.dispatch('sendAction', payload).then(response => {
        this.$refs.multisite.$refs.multisiteModel.hide();
        this.$store.commit("SET_SITES", response.data.getSitesV3);
          this.$store.commit("SET_GROUPS", response.data.getGroupsSitesV3);
          this.$store.commit(
            "UPDATE_SITES_UPDATES",
            response.data.getSitesUpdatesV3
          );
          this.$store.commit(
            "UPDATE_PLUGINS_AND_THEMES",
            response.data.getPluginsAndThemesV3
          );

      });
    },
    handlePaste(key) {
      setTimeout(() => {
        let spilitedStrings = this.args[key].split("|^|");
        if (spilitedStrings.length > 1) {
          this.args.url = spilitedStrings[0];
          this.args.username = spilitedStrings[1];
          this.args.activationKey = spilitedStrings[2];
        }
      }, 10);
    }
  }
};
</script>

<style scoped>

</style>
